/* eslint-disable no-undef */
(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('InsuranceService', InsuranceService);

  InsuranceService.$inject = ['$resource'];

  function InsuranceService ($resource) {
    return $resource(apiUrl + '/insurance/:id', { id: '@id' }, {
      paged: { url: apiUrl + '/reports/insurance/filter', method: 'POST', params: {}, isArray: false },
      loadClientDatas: { url: apiUrl + '/insurance/load-client-datas', method: 'POST', params: {}, isArray: false },
      sendProposal: { url: apiUrl + '/insurance/send-proposal', method: 'POST', params: {}, isArray: false },
      sendSignature: { url: apiUrl + '/insurance/send-signature', method: 'POST', params: {}, isArray: false },
      loadBasicReport: { url: apiUrl + '/reports-insurance/download', method: 'POST', params: {}, isArray: false },
      resendUserToken: { url: apiUrl + '/insurance/resend-user-token', method: 'POST', params: {}, isArray: false },
      getBanks: { url: apiUrl + '/insurance/get-banks', method: 'POST', params: {}, isArray: true },
      getBankInformations: { url: apiUrl + '/insurance/get-bank-informations', method: 'POST', params: {}, isArray: false },
      verifyIfAgeIsAllowedToGetInsurance: { url: apiUrl + '/insurance/age-is-allow', method: 'POST', params: {}, isArray: false },
      getAddressByZipCode: { url: apiUrl + '/insurance/get-address-by-zipcode', method: 'POST', params: {}, isArray: false },
      updateStatus: { url: apiUrl + '/insurance/update-status', method: 'POST', params: { }, isArray: false },
      getOccupations: { url: apiUrl + '/insurance/get-occupations', method: 'POST', params: { }, isArray: true },
      getOccupationByCode: { url: apiUrl + '/insurance/get-occupation-by-code', method: 'POST', params: { }, isArray: false },
      getOccupationsCategories: { url: apiUrl + '/insurance/get-occupations-categories', method: 'POST', params: { }, isArray: true },
      saveOccupations: { url: apiUrl + '/insurance/save-occupations', method: 'POST', params: { }, isArray: true },
      getProposalByHash: { url: apiUrl + '/insurance/get-proposal-by-hash', method: 'POST', params: {}, isArray: false },
      sendUserTokenBySms: { url: apiUrl + '/insurance/send-user-token-by-sms', method: 'POST', params: {}, isArray: false },
      verifyMessage: { url: apiUrl + '/insurance/verify-message', method: 'POST', params: {}, isArray: false }
    })
  }
})();